<template>
  <div class="side-bar">
    <el-menu
      router
      :default-active="activeMenuItem"
      :collapse="collapse"
      :collapse-transition="false"
      unique-opened
      overflow="y-auto"
      h="full"
    >
      <template v-for="menu in sideMenu">
        <side-bar-item :key="menu.menuId" :item="menu" />
      </template>
    </el-menu>
    <div ref="dragResizer" class="drag-resizer"></div>
    <div ref="menuCollapser" class="menu-collapser-wrapper">
      <div v-if="showCollapser" v-motion-fade class="menu-collapser flex items-center" @click="toggleCollapse">
        <i v-if="collapse" class="el-icon-caret-right -ml-2px"></i>
        <i v-else class="el-icon-caret-left -ml-2px"></i>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import SideBarItem from './SideBarItem.vue';
import { fixPath } from '@/router';
const routerStore = useRouterStore();
const sideMenu = computed(() => routerStore.sideMenu);
const route = useRoute();
// const activeMenuItem = computed(() => fixPath(route.path).split('/').slice(0, 4).join('/'));
const dragResizer = ref<HTMLElement | null>(null);
const menuCollapser = ref<HTMLElement | null>(null);
const resizerHover = useElementHover(dragResizer);
const collapserHover = useElementHover(menuCollapser);
const showCollapser = computed(() => resizerHover.value || collapserHover.value);
const appStore = useAppStore();
const { toggleCollapse, setSideBarWidth } = appStore;
const { collapse } = storeToRefs(appStore);
const { x } = useDraggable(dragResizer);

watch(x, (val) => setSideBarWidth(val));

const activeMenuItem = computed(() => {
  const path = fixPath(route.path);
  const findItem = routerStore.menuList
    ?.filter((item: any) => item?.path && (path === item.path || path.startsWith(`${item.path}/`)))
    .sort((a: any, b: any) => b.path.length - a.path.length)[0];
  if (findItem) return findItem?.path;
  return path;
});
</script>
<style lang="scss" scoped>
.side-bar {
  background: #2c405a;
  width: var(--side-bar-width);
  height: calc(100vh - var(--nav-bar-height));
  position: relative;

  *::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  ::-webkit-scrollbar-track {
    box-shadow: none;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 6px;
    border: 2px inset transparent;
    background-color: transparent;
  }

  :hover::-webkit-scrollbar-thumb {
    background-color: #798696;
  }

  /* For Firefox */
  @-moz-document url-prefix() {
    * {
      scrollbar-width: thin;
    }
  }
}

.el-menu {
  border-right: none;
  background-color: transparent;
  overflow-x: hidden;
}

.el-menu--collapse {
  width: 56px;
}

.drag-resizer {
  position: absolute;
  z-index: 1010;
  top: 0;
  bottom: 0;
  right: -6px;
  width: 12px;
  user-select: none;
  cursor: col-resize;
}

.menu-collapser-wrapper {
  width: 32px;
  height: 70px;
  position: absolute;
  padding-top: 14px;
  right: -16px;
  top: calc(50% - var(--nav-bar-height));
  left: auto;
  transform: translateY(-50%);
  cursor: pointer;
  z-index: 1012;

  .menu-collapser {
    height: 44px;
    width: 14px;
    background-color: white;
    border: 1px solid var(--border-color-base);
    box-shadow: 0 2px 8px 0 rgb(0 0 0 / 6%);
    border-radius: 8px;
    line-height: 28px;
    text-align: center;
    z-index: 999;
    margin-left: 10px;
  }
}
</style>
